import { createClient } from '@supabase/supabase-js';

// Default values for development - replace with your actual Supabase project URL and anon key
const DEFAULT_SUPABASE_URL = 'https://your-project-url.supabase.co';
const DEFAULT_SUPABASE_KEY = 'your-anon-key';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || DEFAULT_SUPABASE_KEY;

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn('WARNING! Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY environment variables for production.');
}

export const supabase = createClient(supabaseUrl, supabaseKey); 